import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export interface useBuscarLeadInterface {
  params: string;
}

export function useBuscarLead(
  props: useBuscarLeadInterface & QueryGlobalInterface
) {
  const fetchData = async () => {
    const BUSCAR_LEAD = `${leadsWebEnviroment}/commom/leads/buscar-lead/v1${props.params}`;
    const response = await instance.get(BUSCAR_LEAD);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    cacheTime: 0,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar lead. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
